import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { TopNetworkLanes } from '../../../interfaces/networkInsightsServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const TOP_NETWORK_LANES_REQUEST = 'TOP_NETWORK_LANES_REQUEST';
export const TOP_NETWORK_LANES_SUCCESS = 'TOP_NETWORK_LANES_SUCCESS';
export const TOP_NETWORK_LANES_FAILURE = 'TOP_NETWORK_LANES_FAILURE';

const requestTopNetworkLanes = (): object => {
    return {
        type: TOP_NETWORK_LANES_REQUEST
    };
};

const receiveTopNetworkLanes = (json: object): object => {
    return {
        type: TOP_NETWORK_LANES_SUCCESS,
        payload: json
    };
};

const requestTopNetworkLanesFailed = (): object => {
    return {
        type: TOP_NETWORK_LANES_FAILURE
    };
};

export const fetchTopNetworkLanes = (query: any): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestTopNetworkLanes());

        try {
            const json: TopNetworkLanes[] = await ApiService.post(Endpoints.networkLanes, query, true);

            if (Object.keys(json).length > 0) {
                dispatch(receiveTopNetworkLanes(json));
            } else {
                dispatch(receiveTopNetworkLanes({}));
            }
        } catch (err) {
            dispatch(requestTopNetworkLanesFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching top network lanes.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
